"use client";

import { useMemo } from "react";

import type { QRProps } from "@/contexts/QREditorContext/types";
import { UseEmailDataResult, EmailTemplateTranslations } from "../types";
import { usePreviewData } from "@/features/previews/shared/hooks/usePreviewData";

/**
 * Resolves email preview data from props with QREditorContext fallback.
 */
export const useEmailData = (props: QRProps<"email">): UseEmailDataResult => {
  const { data, isInitPreview: isInitialPreview } = usePreviewData(props);

  const translations = props.previewTranslations?.["email"] as EmailTemplateTranslations;

  const { email, subject, message } = useMemo(() => {
    if (!data) {
      return {
        email: "",
        subject: "",
        message: "",
      };
    }

    return {
      email: data.email ?? "",
      subject: data.subject ?? "",
      message: data.message ?? "",
    };
  }, [data]);

  return {
    translations,
    isInitialPreview,
    data,
    email,
    subject,
    message,
  };
};
